"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var getFontSize_exports = {};
__export(getFontSize_exports, {
  getFontSize: () => getFontSize,
  getFontSizeToken: () => getFontSizeToken,
  getFontSizeVariable: () => getFontSizeVariable
});
module.exports = __toCommonJS(getFontSize_exports);
var import_core = require("@tamagui/core");
var getFontSize = function(inSize, opts) {
  var res = getFontSizeVariable(inSize, opts);
  if ((0, import_core.isVariable)(res)) {
    return +res.val;
  }
  return res ? +res : 16;
};
var getFontSizeVariable = function(inSize, opts) {
  var token = getFontSizeToken(inSize, opts);
  if (!token) {
    return inSize;
  }
  var conf = (0, import_core.getConfig)();
  var font = conf.fontsParsed[(opts === null || opts === void 0 ? void 0 : opts.font) || conf.defaultFontToken];
  return font === null || font === void 0 ? void 0 : font.size[token];
};
var getFontSizeToken = function(inSize, opts) {
  if (typeof inSize === "number") {
    return null;
  }
  var relativeSize = (opts === null || opts === void 0 ? void 0 : opts.relativeSize) || 0;
  var conf = (0, import_core.getConfig)();
  var font = conf.fontsParsed[(opts === null || opts === void 0 ? void 0 : opts.font) || conf.defaultFontToken];
  var fontSize = (font === null || font === void 0 ? void 0 : font.size) || // fallback to size tokens
  conf.tokensParsed.size;
  var _ref;
  var size = (_ref = inSize === "$true" && !("$true" in fontSize) ? "$4" : inSize) !== null && _ref !== void 0 ? _ref : "$true" in fontSize ? "$true" : "$4";
  var sizeTokens = Object.keys(fontSize);
  var foundIndex = sizeTokens.indexOf(size);
  if (foundIndex === -1) {
    if (size.endsWith(".5")) {
      foundIndex = sizeTokens.indexOf(size.replace(".5", ""));
    }
  }
  if (process.env.NODE_ENV === "development") {
    if (foundIndex === -1) {
      console.warn("No font size found", size, opts, "in size tokens", sizeTokens);
    }
  }
  var tokenIndex = Math.min(Math.max(0, foundIndex + relativeSize), sizeTokens.length - 1);
  var _sizeTokens_tokenIndex;
  return (_sizeTokens_tokenIndex = sizeTokens[tokenIndex]) !== null && _sizeTokens_tokenIndex !== void 0 ? _sizeTokens_tokenIndex : size;
};
//# sourceMappingURL=getFontSize.js.map
